import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import api from "../lib/api";
import { PORTFOLIO_CATEGORIES } from "../data/site";
import { Reveal, SectionHeading } from "./Reveal";

export const Portfolio = () => {
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => {});
  }, []);

  const filtered = filter === "All" ? projects : projects.filter((p) => p.category === filter);

  return (
    <section id="portfolio" className="mx-auto max-w-7xl px-5 md:px-8 py-24 md:py-32">
      <Reveal>
        <SectionHeading
          overline="Portfolio"
          title="Work That Turns Heads"
          sub="A snapshot of trailers, trucks, fleets and buildings we've branded across Australia."
        />
      </Reveal>

      <div className="mt-10 flex flex-wrap gap-2">
        {PORTFOLIO_CATEGORIES.map((c) => (
          <button
            key={c}
            data-testid={`filter-${c.replace(/\s+/g, "-").toLowerCase()}`}
            onClick={() => setFilter(c)}
            className={`font-head text-sm uppercase tracking-wider px-5 py-2.5 border transition-colors ${
              filter === c
                ? "bg-orange border-orange text-white"
                : "border-line text-white/60 hover:text-white hover:border-white/40"
            }`}
          >
            {c}
          </button>
        ))}
      </div>

      <div className="mt-10 masonry columns-1 sm:columns-2 lg:columns-3">
        <AnimatePresence>
          {filtered.map((p, i) => (
            <motion.div
              key={p.id}
              layout
              initial={{ opacity: 0, scale: 0.96 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4, delay: (i % 6) * 0.05 }}
              data-testid={`portfolio-item-${i}`}
              className="group relative overflow-hidden border border-line"
            >
              <img
                src={p.image_url}
                alt={p.title}
                loading="lazy"
                className="w-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink-900 via-ink-900/20 to-transparent opacity-80 group-hover:opacity-95 transition-opacity" />
              <div className="absolute bottom-0 left-0 p-5">
                <span className="overline text-[0.65rem]">{p.category}</span>
                <h3 className="font-head font-extrabold uppercase text-lg tracking-tight">{p.title}</h3>
              </div>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>

      {filtered.length === 0 && (
        <p className="mt-10 text-white/40 text-center">No projects in this category yet.</p>
      )}
    </section>
  );
};
